import { LanguageModelFields } from './interface';

export const languageInitialValues: LanguageModelFields = {
  languages: [],
};
